var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Change Client Name")])])])]), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Shipment ID:")]), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  }, [_vm._v("*")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-cart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentId),
      expression: "shipmentId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shipmentId')
    },
    attrs: {
      "type": "text",
      "placeholder": "Please Enter Shipment ID",
      "name": "Shipment ID",
      "id": "shipmentId",
      "disabled": _vm.disablefield
    },
    domProps: {
      "value": (_vm.shipmentId)
    },
    on: {
      "select": _vm.selectClient,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Shipment ID')),
      expression: "errors.has('Shipment ID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Shipment ID')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSubmitSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n                Search")]), _vm._v("   \n              "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])]), _vm._v(" "), (_vm.showclient) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Client Name:")]), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  }), _vm._v("* ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.Clientlist,
      "clearable": false,
      "name": "CompanyList",
      "placeholder": "Select Client",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true,
      "disabled": _vm.disablefields
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.showclient) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Client Name List:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  }, [_vm._v("*")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.Clientlist,
      "clearable": false,
      "name": "CompanyList",
      "placeholder": "Select Client",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true
    },
    on: {
      "select": _vm.selectClient
    },
    model: {
      value: (_vm.clientname),
      callback: function($$v) {
        _vm.clientname = $$v
      },
      expression: "clientname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('client')),
      expression: "errors.has('client')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('client')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showclient) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Comments:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#449d42",
      "font-size": "11px"
    }
  }, [_vm._v("Note:Maximum Length 500 character")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user' style='font-size: 12px'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    attrs: {
      "name": "comments",
      "id": "comments",
      "placeholder": "Enter Comments",
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter comment")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientbusinessaccountid != _vm.oldclientbusinessaccountid),
      expression: "clientbusinessaccountid!=oldclientbusinessaccountid"
    }],
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Update")]), _vm._v("   \n          ")])], 1)]) : _vm._e()])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b0a0092","hasScoped":true}!./src/modules/utility/views/updateBookingDetails/changeclientname/changeclientname.component.html
// module id = 2192
// module chunks = 3